import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  & .left-side {
    max-width: 48%;
    padding-right: 1.5rem;
    flex: 1;
  }
  & .right-side {
    max-width: 48%;
    padding-left: 1.5rem;
    flex: 1;
    & .hefesto-button {
      width: 100%;
      margin-top: 1rem;
    }
  }
  & .search-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.5rem;
  }
`;
